import { RouteConfig } from 'vue-router'
import { mobileAppRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const MobileAppCustomiserMicroApp = () =>
  import(
    '@/pmd/pages/mobileAppCustomiser/MobileAppCustomiserMicroApp.vue'
  ).then(m => m.default)

export const mobileAppRoute: RouteConfig[] = [
  {
    path: 'mobile_app',
    name: mobileAppRouteNames.default,
    component: MobileAppCustomiserMicroApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
]
